import React, { useState, useEffect } from "react";
import Firebase from "../firebasehelper";
import { coins } from "../Utils/Constants";
import Dropdown from "./Dropdown";

const PercentCoin = require("../assets/media/coins/percent-coin.png");

const getDefaultOption = (brandName) => {
  return {
    label: `A gift from ${brandName}`,
    value: `A gift from ${brandName}`,
    isDefault: true,
  };
};

export default function AssignTokenContainer({
  tokenTasks,
  territory,
  onChange,
  initialPayload,
  brandName,
  hex,
  white,
}) {
  const [shoppingTokens, setShoppingTokens] = useState(0);
  const [premierTokens, setPremierTokens] = useState(0);
  const [agencyData, setAgencyData] = useState({});
  const [categoryOptions, setCategoryOptions] = useState([
    getDefaultOption(brandName),
  ]);
  const [selectedOption, setSelectedOption] = useState(
    getDefaultOption(brandName)
  );

  const uid = localStorage.getItem("uid");

  useEffect(() => {
    const getOptions = () => {
      return tokenTasks
        .map((task) => ({
          label: task.title,
          value: task.id,
          token: task.token,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
    };

    const categories = getOptions();
    setCategoryOptions((prevState) => [...prevState, ...categories]);
  }, [tokenTasks]);

  useEffect(() => {
    if (initialPayload) {
      const { shoppingTokens, premierTokens, category } = initialPayload;
      if (category) {
        setShoppingTokens(shoppingTokens);
        setPremierTokens(premierTokens);
        setSelectedOption(category);
      }
    }
  }, [initialPayload]);

  useEffect(() => {
    const profile = localStorage.getItem("profile");
    if (!profile) {
      Firebase.getAgencyData(uid, (res) => {
        setAgencyData(res);
      });
    } else setAgencyData(profile);
  }, [uid]);

  useEffect(() => {
    const category = selectedOption.label;
    onChange({ shoppingTokens, premierTokens, category, adminId: uid });
  }, [shoppingTokens, premierTokens, selectedOption]);

  const handleChangeShoppingToken = ({ target }) => {
    setShoppingTokens(parseInt(target.value || 0, 10));
  };

  const handleChangePremierToken = ({ target }) => {
    setPremierTokens(parseInt(target.value || 0, 10));
  };

  const handleSelectCategory = (value) => {
    setSelectedOption(value);
  };

  return (
    <div style={{ width: "94%", marginBottom: 20 }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: 300,
          marginBottom: 10,
        }}
      >
        <p>Shopping tokens</p>
        <div
          className="row-div"
          style={{ width: "fit-content", marginLeft: "auto" }}
        >
          <input
            className="form-control"
            type="text"
            name="price"
            style={{ width: 100, marginRight: 10 }}
            onChange={handleChangeShoppingToken}
            value={shoppingTokens || 0}
          />
          <img src={PercentCoin} width="40px" height="40px" alt="coin" />
        </div>
      </div>
      {agencyData &&
        ![
          "Sales manager",
          "Sales rep",
          "Service manager",
          "Service rep",
        ].includes(agencyData.type) && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: 300,
              marginBottom: 10,
            }}
          >
            <p>Premier tokens</p>
            <div
              className="row-div"
              style={{ width: "fit-content", marginLeft: "auto" }}
            >
              <input
                className="form-control"
                type="text"
                name="price"
                style={{ width: 100, marginRight: 10 }}
                onChange={handleChangePremierToken}
                value={premierTokens || 0}
              />
              <img
                src={coins[territory || "UK"]}
                width="40px"
                height="40px"
                alt="coin"
              />
            </div>
          </div>
        )}
      {!agencyData ||
      ![
        "Sales manager",
        "Sales rep",
        "Service manager",
        "Service rep",
      ].includes(agencyData.type) ? (
        <Dropdown
          options={categoryOptions}
          onClick={handleSelectCategory}
          value={selectedOption}
          id="assign-tokens-category"
          hex={hex}
          white={white}
        />
      ) : (
        <input
          type="text"
          value={selectedOption.label}
          className="form-control"
          disabled
          style={{ width: "100%" }}
        />
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/AssignTokenContainer.js